import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { AuthenticationService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class PublicGuard implements CanLoad {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  public canLoad() {
    if (this.authService.hasToken()) {
      return this.router.parseUrl('/');
    }

    return true;
  }
}
